<template>
  <div class="service">

    <sectionHeader :text="data.header"></sectionHeader>

    <serviceGlyph :service="service" />

    <sectionSummary :text="data.summary"></sectionSummary>

    <ulList :header="data.listHeader" :list="data.list"></ulList>

  </div>
</template>

<script>
import sectionHeader from '../text/SectionHeader'
import sectionSummary from '../text/SectionSummary'
import ulList from '../list/ULList'
import serviceGlyph from './glyph'

export default{
  name: 'service',
  props: [
    'data',
    'service'
  ],
  components: {
    sectionHeader,
    sectionSummary,
    ulList,
    serviceGlyph
  }
}

</script>

<style scoped>

svg {
  display: block;
  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/services/Service.vue